import { lazy } from 'react';

// One component per entry in paths.js, loaded only when its page is visited
export const PAGES = {
  dnd: lazy(() => import('../dnd/DndPage')),
  mc: lazy(() => import('../mc/McPage')),
  odyssey: lazy(() => import('../odyssey/OdysseyPage')),
  blackmarkedman: lazy(() => import('../blackmarkedman/BlackMarkedManPage')),
  voidworld: lazy(() => import('../voidworld/VoidWorldPage')),
  wwi: lazy(() => import('../wwi/WwiEntry')),
  lorraine: lazy(() => import('../lorraine/LorrainePage')),
  battle: lazy(() => import('../lorraine/BattleRedirect')),
  ytlab: lazy(() => import('../lab/YtLabPage')),
  gmh: lazy(() => import('../gmh/GmhPage')),
  talk: lazy(() => import('../talk/TalkPage')),
  underconstruction: lazy(() => import('../underconstruction/UnderConstructionPage')),
  rpg: lazy(() => import('../rpg/RpgPage')),
  dienasty: lazy(() => import('../dienasty/DienastyPage'))
};
